import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import simulatorRegionsJsonData from "../config/simulator_regions.json";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    simulatorRegions: simulatorRegionsJsonData,
    selectedRegion: {},
    selectedNavigationOption: {},
    feedbackText: "",
    starRating: "",
    lowInternetBandwith: false,
    alertForm: {
      alertInfo: {
        messageId: "",
        sender: '',
        messageType: '',
        status: '',
        scope: '',
      },
      eventInfo: {
        eventType: '',
        // category: [],
        // responseType: [],
        urgency: '',
        severity: '',
        certainty: '',
      },
      eventDescription: '',
      instruction: ''
    }
  },
  mutations: {
    assignSelectedRegion(state, selectedRegion) {
      state.selectedRegion = selectedRegion;
    },
    assignSelectedNavigationOption(state, selectedNavigationOption) {
      state.selectedNavigationOption = selectedNavigationOption;
    },
    updateMessageId(state, messageId) {
      state.alertForm.alertInfo.messageId = messageId;
    },
    updateSender(state, sender) {
      state.alertForm.alertInfo.sender = sender;
    },
    updateMessageType(state, messageType) {
      state.alertForm.alertInfo.messageType = messageType;
    },
    updateStatus(state, status) {
      state.alertForm.alertInfo.status = status;
    },
    updateScope(state, scope) {
      state.alertForm.alertInfo.scope = scope;
    },
    updateEventType(state, eventType) {
      state.alertForm.eventInfo.eventType = eventType;
    },
    updateUrgency(state, urgency) {
      state.alertForm.eventInfo.urgency = urgency;
    },
    updateSeverity(state, severity) {
      state.alertForm.eventInfo.severity = severity;
    },
    updateCertainty(state, certainty) {
      state.alertForm.eventInfo.certainty = certainty;
    },
    updateTimestamp(state, timestamp) {
      state.alertForm.eventInfo.timeSent = timestamp;
    },
    updateDescription(state, description) {
      state.alertForm.eventDescription = description;
    },
    updateInstruction(state, instruction) {
      state.alertForm.instruction = instruction;
    },
    updateFeedback(state, feedback) {
      state.feedbackText = feedback;
    },
    updateStarRating(state, rating) {
      state.starRating = rating;
    },
    updateLowInternetBandwithMode(state, mode) {
      state.lowInternetBandwith = mode;
    }
  },
  actions: {},
  modules: {},
  getters: {
    getSimulators: (state) => {
      return state.simulatorRegions;
    },
    getSelectedRegion: (state) => {
      return state.selectedRegion;
    },
    getAlertInfo: (state) => {
      return state.alertForm.alertInfo;
    },
    getEventInfo: (state) => {
      return state.alertForm.eventInfo;
    },
    getDescription: (state) => {
      return state.alertForm.eventDescription;
    },
    getInstruction: (state) => {
      return state.alertForm.instruction;
    },
    getAllFormValues: (state) => {
      return state.alertForm;
    },
    getSelectedNavigationOption: (state) => {
      return state.selectedNavigationOption;
    },
    getFeedbackValue: (state) => {
      return state.feedbackText;
    },
    getStarRating: (state) => {
      return state.starRating;
    },
    getLowInternetBandwithMode: (state) => {
      return state.lowInternetBandwith;
    }
  },
});
